const getColor = (type) => {
  switch (type) {
    case 'success':
      return 'green';
    case 'info':
      return 'blue';
    case 'danger':
      return 'red';
    case 'warning':
      return 'yellow';
  }
};

const getIcon = (icon, type) => {
  if (icon) return icon;
  switch (type) {
    case 'success':
      return 'checked';
    case 'info':
      return 'info';
    case 'danger':
      return 'sad';
    case 'warning':
      return 'warning';
  }
};

export { getIcon, getColor };
